import React, { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Header } from '../header';

interface LayoutProps {
  children: ReactNode;
}

export const ClientPageLayout: React.FC<LayoutProps> = ({ children }) => {

  //   // useEffect(() => {
  // if (
  //   !searchByVIN?.vins?.length &&
  //   !searchByVIN?.marks?.length &&
  //   searchDetails?.length &&
  //   !searchByVINLoading
  //   !searchDetailsLoading
  // ) {
  //   navigate(
  //     generatePath(routes.CATALOG_SEARCH_BAR_RESULTS, {
  //       searchText: inputValue,
  //     }),
  //   );
  //   // navigate(routes.CATALOG_SEARCH_BAR_RESULTS);
  //   onClose();
  // }
  // }, [searchByVIN, searchByVINLoading, inputValue]);

  return (
    <Box display="grid" gridTemplateRows="132px 1fr">
      <Header />
      <Box as="main" m="auto" mt="132px" maxW="1316px" w="100%">
        {children}
      </Box>
    </Box>
  );
};
